import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

var Incidencia = Object.create(DatabaseModel);

Incidencia.model = 'incidencias';
Incidencia.modelFront = 'incidencias';

// GET /movilidad/incidencias?estado=&tipo= → List<PlanIncidencia> (viaja en ResponseDto.list;
// unwrapDto devuelve null con lista vacía, de ahí el || []).
Incidencia.listar = function(estado, tipo) {
    var self = this;
    var qs = [];
    if (estado) qs.push('estado=' + encodeURIComponent(estado));
    if (tipo) qs.push('tipo=' + encodeURIComponent(tipo));
    var query = qs.length ? '?' + qs.join('&') : '';
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + query,
        method: 'GET'
    }, false).then(unwrapDto).then(function(res) { return res || []; });
};

// PUT /movilidad/incidencias/{id}/resolver → incidencia resuelta
Incidencia.resolver = function(id) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id) + '/resolver',
        method: 'PUT'
    }, false).then(unwrapDto);
};

export default Incidencia;
